import { z } from 'zod'
import { Model } from './architecture'

export const CityValidation = z.object({
  value: z.string({ required_error: '[City] value is required' }),
})

export class City extends Model {
  static create({ value }: z.infer<typeof CityValidation>) {
    CityValidation.parse({ value })
    return new City(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
